import { render, staticRenderFns } from "./LazyDiv.vue?vue&type=template&id=7dcb2f23&"
import script from "./LazyDiv.vue?vue&type=script&lang=js&"
export * from "./LazyDiv.vue?vue&type=script&lang=js&"
import style0 from "./LazyDiv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LazyDiv.vue"
export default component.exports